export const NOT_FOUND        = 'NOT_FOUND';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const SERVER_ERROR     = 'SERVER_ERROR';
export const UNKNOWN_ERROR    = 'UNKNOWN_ERROR';
export const UNAUTHORIZED     = 'UNAUTHORIZED';
